import { call, put, takeLatest } from "redux-saga/effects";
import {
  SG_GET_STATUS_ORDERS,
  GET_STATUS_ORDERS,
  SG_FETCH_STATUS_ORDER,
  FETCH_STATUS_ORDER,
  SG_ADD_STATUS_ORDER,
  ADD_STATUS_ORDER,
  SG_EDIT_STATUS_ORDER,
  EDIT_STATUS_ORDER,
  SG_DELETE_STATUS_ORDER,
  DELETE_STATUS_ORDER,
  SG_STATUS_ORDERS_STATISTICS,
  STATUS_ORDERS_STATISTICS,
  SG_GET_STATUS_ORDERS_BY_TABLE,
  GET_STATUS_ORDERS_BY_TABLE,
  STATUS_ORDERS_PENDING,
  GET_ERRORS,
} from "constants/actions";

import * as API from "constants/api";

// ==================== GET ALL STATUS ORDERS ====================
function* getStatusOrders(action) {
  try {
    yield put({ type: STATUS_ORDERS_PENDING });
    const { queryParams } = action.payload || {};
    const response = yield call(API.GET_STATUS_ORDERS, queryParams);
    yield put({ type: GET_STATUS_ORDERS, payload: response.data });
  } catch (error) {
    console.error("getStatusOrders error:", error);
    yield put({
      type: GET_ERRORS,
      payload: { error: error.response?.data || "Failed to fetch status orders" },
    });
  }
}

// ==================== FETCH SINGLE STATUS ORDER ====================
function* fetchStatusOrder(action) {
  try {
    yield put({ type: STATUS_ORDERS_PENDING });
    const response = yield call(API.FETCH_STATUS_ORDER, action.payload);
    yield put({ type: FETCH_STATUS_ORDER, payload: response.data });
  } catch (error) {
    console.error("fetchStatusOrder error:", error);
    yield put({
      type: GET_ERRORS,
      payload: { error: error.response?.data || "Failed to fetch status order" },
    });
  }
}

// ==================== ADD STATUS ORDER ====================
function* addStatusOrder(action) {
  try {
    yield put({ type: STATUS_ORDERS_PENDING });
    const response = yield call(API.ADD_STATUS_ORDER, action.payload);
    yield put({ type: ADD_STATUS_ORDER, payload: response.data });
  } catch (error) {
    console.error("addStatusOrder error:", error);
    yield put({
      type: GET_ERRORS,
      payload: { error: error.response?.data || "Failed to create status order" },
    });
  }
}

// ==================== EDIT STATUS ORDER ====================
function* editStatusOrder(action) {
  try {
    yield put({ type: STATUS_ORDERS_PENDING });
    const response = yield call(API.EDIT_STATUS_ORDER, action.payload);
    yield put({ type: EDIT_STATUS_ORDER, payload: response.data });
  } catch (error) {
    console.error("editStatusOrder error:", error);
    yield put({
      type: GET_ERRORS,
      payload: { error: error.response?.data || "Failed to update status order" },
    });
  }
}

// ==================== DELETE STATUS ORDER ====================
function* deleteStatusOrder(action) {
  try {
    yield put({ type: STATUS_ORDERS_PENDING });
    yield call(API.DELETE_STATUS_ORDER, action.payload);
    yield put({ 
      type: DELETE_STATUS_ORDER, 
      payload: { id: action.payload.id } 
    });
  } catch (error) {
    console.error("deleteStatusOrder error:", error);
    yield put({
      type: GET_ERRORS,
      payload: { error: error.response?.data || "Failed to delete status order" },
    });
  }
}

// ==================== STATUS ORDER STATISTICS ====================
function* statusOrdersStatistics(action) {
  try {
    yield put({ type: STATUS_ORDERS_PENDING });
    const { queryParams } = action.payload || {};
    const response = yield call(API.STATUS_ORDER_STATISTICS, queryParams);
    yield put({ type: STATUS_ORDERS_STATISTICS, payload: response.data });
  } catch (error) {
    console.error("statusOrdersStatistics error:", error);
    yield put({
      type: GET_ERRORS,
      payload: { error: error.response?.data || "Failed to fetch statistics" },
    });
  }
}

// ==================== GET STATUS ORDERS BY TABLE ====================
function* getStatusOrdersByTable(action) {
  try {
    yield put({ type: STATUS_ORDERS_PENDING });
    const { table_name, query } = action.payload;
    const response = yield call(API.GET_STATUS_ORDERS_BY_TABLE, { table_name, query });
    yield put({ 
      type: GET_STATUS_ORDERS_BY_TABLE, 
      payload: { 
        table_name, 
        data: response.data 
      } 
    });
  } catch (error) {
    console.error("getStatusOrdersByTable error:", error);
    yield put({
      type: GET_ERRORS,
      payload: { error: error.response?.data || "Failed to fetch status orders by table" },
    });
  }
}

// ==================== WATCHERS ====================
export default function* ActionPlanningStatusSaga() {
  yield takeLatest(SG_GET_STATUS_ORDERS, getStatusOrders);
  yield takeLatest(SG_FETCH_STATUS_ORDER, fetchStatusOrder);
  yield takeLatest(SG_ADD_STATUS_ORDER, addStatusOrder);
  yield takeLatest(SG_EDIT_STATUS_ORDER, editStatusOrder);
  yield takeLatest(SG_DELETE_STATUS_ORDER, deleteStatusOrder);
  yield takeLatest(SG_STATUS_ORDERS_STATISTICS, statusOrdersStatistics);
  yield takeLatest(SG_GET_STATUS_ORDERS_BY_TABLE, getStatusOrdersByTable);
}
